(() => {
  function formatDescriptions(root = document) {
    root.querySelectorAll('.product__description').forEach(description => {
      description.querySelectorAll('p').forEach(p => {
        const text = p.textContent.trim();
        if (/^(?:🌿|💖|🩵|💝|✨|💫)?\s*(?:Détails\s*:|Les petits détails|Pourquoi on (?:les )?adore\s*\??)/u.test(text) && text.length < 100) {
          p.classList.add('crycry-product-heading');
        }
        if (!p.closest('.crycry-options-box') && /^(?:▶️?|👉|✨|💡)?\s*Option créoles\s*:/u.test(text)) {
          p.classList.add('crycry-creoles-note');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => formatDescriptions());
  else formatDescriptions();
  document.addEventListener('shopify:section:load', event => formatDescriptions(event.target));
})();